export enum PacketSizeConfiguration {
  END_STRING = "End String",
  PACKET_SIZE = "Packet Size",
}
